module.exports = __webpack_public_path__ + "static/iqube-6e5633432890bf9be39c22005c539386.svg";